import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type WithOnboardingAnalyticsCategory } from './onboardingAnalytics';
import META from './useTrackCompletedOnboardingUpload.meta';

export type CompletedOnboardingUploadParams = WithOnboardingAnalyticsCategory;

export const useTrackCompletedOnboardingUpload = () => {
  const { track } = useAnalyticsUtilities();

  const trackCompletedOnboardingUpload = useCallback(
    (params: CompletedOnboardingUploadParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCompletedOnboardingUpload };
};
